import React, { useState }  from 'react'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Description from '@components/ContentItem/Description'
import WebContent from '@components/ContentItem/WebContent'
import PdfViewer from '@components/ContentItem/PdfViewer'
import './TabsOverrides.css'

const MainContentDisplay = ({doc}) => { 
    let descriptionIsEmptyOrNull = doc.data.description === null || doc.data.description.length === 0 || doc.data.description === "";
    let richTextIsEmptyOrNull = doc.data.content === null || doc.data.content.raw.length === 0;
    const [key, setKey] = useState('summary');
    if((!descriptionIsEmptyOrNull|| !richTextIsEmptyOrNull) && doc.data.resource_type === "Document" && doc.data.content_item_path !== null){
        return (
            <Tabs 
            id={doc.uid} 
            activeKey={key}
            defaultActiveKey="summary" 
            onSelect={(k) => setKey(k)}
            >
                <Tab eventKey="summary" title="Summary" className="mt-3">
                    <Description description={doc.data.description}/>
                    <WebContent content={doc.data.content} resource_type={doc.data.resource_type} />
                </Tab>
                <Tab eventKey="viewPdf" title="View/Download PDF" className="mt-3">
                    <PdfViewer doc={doc}/>
                </Tab>            
            </Tabs>
        )
    }
    else if(doc.data.resource_type === "Document" && doc.data.content_item_path !== null){
        return (
            <PdfViewer doc={doc}/>
        )
    }
    else {
        return (
            <>
            <Description description={doc.data.description}/>
            <WebContent content={doc.data.content} resource_type={doc.data.resource_type} />
            </>
        )
    }
}

export default MainContentDisplay;